import cx from 'classnames';
import React from 'react';
import styles from './stat.module.css';
import { Icon } from 'assets/icons';
import { formatMetric, toReadableNumber } from 'app/shared/utils/number';

export const RelativeStatCard = ({ title, main_value, previous_value, current_value, period }) => {
  const determineChange = (current, previous) => {
    let change = 0;
    if (previous === 0) {
      change = current * 100;
    } else {
      change = ((current - previous) / Math.abs(previous)) * 100;
    }

    if (change > 0) {
      return (
        <span className={cx(styles.badge, styles.positive)}>
          <Icon height={12} width={12} name="arrow_up" />
          {formatMetric(change.toFixed(2))}%
        </span>
      );
    } else if (change < 0) {
      return (
        <span className={cx(styles.badge, styles.negative)}>
          <Icon height={12} width={12} name="arrow_down" />
          {formatMetric(change.toFixed(2))}%
        </span>
      );
    }

    return (
      <span className={cx(styles.badge, styles.positive)}>
        <Icon height={12} width={12} name="arrow_up" />
        0%
      </span>
    );
  };

  return (
    <div className={styles.relativeStatWrapper}>
      <div className={styles.title}>{title}</div>
      <div className={styles.value}>
        {isNaN(main_value) ? main_value || 0 : toReadableNumber(main_value) || 0}
      </div>
      <div className={styles.tagline}>
        <span>{determineChange(current_value, previous_value)}</span>
        {'  '}from last {period}
      </div>
    </div>
  );
};
